<!--<p-blockUI [blocked]="loading"><i class="fa fa-spinner fa-pulse fa-3x fa-fw" style="position:absolute;top:25%;left:50%"></i></p-blockUI>-->
<p-confirmDialog [key]="'CRUDBasicListConfirmDialog_'+CRUDItemBezeichnungPluralCapitalized" appendTo="body" id="smth"
  [style.z-index]="'1006 !important'" [acceptLabel]="translate.instant('Ja',true)"
  [rejectLabel]="translate.instant('Nein',true)"></p-confirmDialog>
<!-- *ngIf="enableConfirm" -->
<ng-container *ngTemplateOutlet="CRUDTemplatePluginTop"></ng-container>
<!--<ng-container *ngIf="false; then CRUDTemplatePluginTop; else CRUDTemplatePluginTop_dummy"></ng-container>-->
<p-table *ngIf="killTable_notInUse != true" #dt id="crudDataTable" [columns]="cols" [value]="crudItems" selectionMode="single"
  [(selection)]="selectedCrudItem" (onRowSelect)="selectCRUDItem($event.data)" dataKey="id" [reorderableColumns]="true"
  (onColReorder)="handleColReorder($event)" [autoLayout]="true" [responsive]="true" csvSeparator=";"
  [exportFilename]="translate.instant(CRUDItemBezeichnungPluralCapitalized,true)" [scrollable]="true"
  [scrollHeight]="scrollHeight" [sortField]="CRUDSortField"
  [virtualRowHeight]="CRUDLazyLoadVirtualRowHeight != null ? CRUDLazyLoadVirtualRowHeight : null"
  [totalRecords]="totalRecords" [lazy]="CRUDLazyLoad" (onLazyLoad)="loadLazy($event)" [virtualScroll]="CRUDLazyLoad"
  [loading]="loadingTable" [rows]="CRUDLazyLoad == true ? 25 : null"
  [tableStyleClass]="'CRUDBasicListTable'"><!-- MODI ggü IMKE: [tableStyleClass]="'CRUDBasicListTable'"-->
  <!-- ungefähre Anzahl Zeilen, die auf den Bildschirm passen. primeNG lädt immer die doppelte Anzahl davon vor -->
  <!--   (onSort)="onSort(dt)" (onFilter)="onFilter(dt)"  -->
  <ng-template pTemplate="caption">
    <ng-container *ngTemplateOutlet="CRUDTemplatePluginTableCaption"></ng-container>

    <!--MODI ggü IMKE: Die Buttonleiste ist in einem Grid, weil in der Mitte: pageTitle -->
    <div *ngIf="CRUDTemplatePluginTableCaption==null" class="titlebar-button-grid">
      <div style="text-align: left;">

        <button *ngIf="CRUDItemButtonTitleNeu!=null && buttonItemsNeuButton==null" type="button" pButton
          icon="fa fa-plus" (click)="addCRUDItem()" [label]="translate.instant('Neu',true)"
          style="width: auto"></button>
        <!-- width: auto - weil: die ListComponent wird teils auch innerhalb eines cardContainers verwendet (Beispiel EingangsrechnungFreigabeCustomizingDetailComponent)-->
        <!--[label]="CRUDItemButtonTitleNeu"-->

        <p-splitButton *ngIf="CRUDItemButtonTitleNeu!=null && buttonItemsNeuButton!=null" icon="fa fa-plus"
          [label]="translate.instant('Neu',true)" (onClick)="neuSplitButtonClicked(null)"
          (onDropdownClick)="neuSplitButtonDropDown(null)" [model]="buttonItemsNeuButton" appendTo="body"
          [style]="{'width': 'auto', 'word-wrap': 'normal'}" [menuStyleClass]="'crudListNeuMenu'"></p-splitButton>
        <!-- [menuStyle]="{'background-color':'yellow !important', 'min-width':'25em !important'}" -->
        <!-- width: auto - weil: die ListComponent wird teils auch innerhalb eines cardContainers verwendet (Beispiel EingangsrechnungFreigabeCustomizingDetailComponent)-->
        <!-- word-wrap: normal - weil: die ListComponent wird teils auch innerhalb eines cardContainers verwendet (Beispiel EingangsrechnungFreigabeCustomizingDetailComponent)-->

        <!--<button type="button" pButton icon="fa fa-filter" (click)="filterClicked(dt)"
          [label]="filterEnabled ? translate.instant('Filter deaktivieren',true) : translate.instant('Filter aktivieren',true)"
          style="margin-left: 5px; width: auto;"></button>-->
        <!--<p-multiSelect [options]="columnOptions" [(ngModel)]="cols"
          [selectedItemsLabel]="'{0} ' + translate.instant('Spalte(n) ausgewählt',false)"
          [style]="{'minWidth': '200px','margin-left':'5px', 'width':'auto'}"
          [defaultLabel]="translate.instant('Spalten für Anzeige wählen',true)" [maxSelectedLabels]="0"
          (onChange)="handleColumnOptionChange($event)" dataKey="header">
        </p-multiSelect>-->
      </div>
      <div style="text-align: center;">
        <span style="line-height: 35px; font-size: medium; font-weight: 500;">{{pageTitle}}</span>
      </div>
      <div style="text-align: right;">
        <span class="p-input-icon-left">
          <i class="fa fa-search"></i>
        <input #gb class="globalFilter" type="text" pInputText [placeholder]="translate.instant('Suche',true)"
          (input)="dt.filterGlobal($event.target.value, 'contains')" style="width: auto">
        </span>
        <!--<button type="button" pButton icon="fa fa-download" label="CSV-Export" (click)="exportCSV(dt)"
          style="margin-left: 5px; width: auto;"></button>-->
        <button *ngIf="CRUDItemHelpTopic != null" type="button" pButton icon="fa fa-question"
          [label]="translate.instant('Hilfe',true)" (click)="showHelp()"
          style="margin-left: 5px; width: auto;"></button>
        <button *ngIf="CRUDItemButtonTitleAktualisieren!=null" type="button" pButton icon="fa fa-redo"
          [label]="translate.instant(CRUDItemButtonTitleAktualisieren,true)" (click)="refresh(dt, gb)"
          style="margin-left: 5px; width: auto;"></button>
      </div>
    </div>

  </ng-template>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <!--<th *ngFor="let col of columns" pReorderableColumn [pSortableColumn]="col.field">
        {{col.header}}
        <p-sortIcon [field]="col.field"></p-sortIcon>
      </th>-->
      <!--<th class="CRUD_HideSplitColumn"></th>--><!--MODI: style="width: 10em;" entfernt!-->
      <ng-container *ngFor="let col of columns">
        <th pReorderableColumn [pSortableColumn]="col.field" [class]="col.thStyleClass">
          {{col.header}}
          <p-sortIcon *ngIf="CRUDLazyLoadServer!=true" [field]="col.field"></p-sortIcon>
        </th>
      </ng-container>
      <th class="CRUD_HideSplitColumn" *ngIf="CRUDHideMehrButton != true"></th><!--MODI: style="width: 10em;" entfernt!-->
    </tr>
    <tr *ngIf="filterEnabled">
    <ng-container *ngFor="let col of columns">
        <!--<th *ngFor="let col of columns" [ngSwitch]="true">-->
          <th [ngSwitch]="true" [class]="col.thStyleClass">
            <!--<p-calendar #filterModified [locale]="DE" (onInput)="getCalendarInputString($event)" (onBlur)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterModified)"
                      appendTo="body" *ngSwitchCase="col.field === 'modified'" dateFormat="dd.mm.yy"></p-calendar>
                      <p-calendar #filterCreated [locale]="DE" (onInput)="getCalendarInputString($event)" (onBlur)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterCreated)"
                      appendTo="body" *ngSwitchCase="col.field === 'created'" dateFormat="dd.mm.yy"></p-calendar>-->
          
            <!-- MODI: Range/Between Calendar-->
            <!-- 'filterDynamicCalendar', habe ich so genannt, weil #filterDynamic_{{col.field}} ist nicht nutzbar, trotzdem funktioniert das, siehe: https://stackoverflow.com/questions/48347854/how-to-set-unique-template-reference-variables-inside-an-ngfor-angular -->
            <!-- Wichtig: onBlur() alleine reicht nicht, denn wenn man im Calendar auf "Monat zurück" - klickt feuert dann schon der Blur! - daher brauchen wir danach per OnSelect() denselben event. -->
            <!--<p-calendar #filterDynamicCalendar (onInput)="getCalendarInputString($event)" [showWeek]="true"
                        (onBlur)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterDynamicCalendar)"
                        (onSelect)="handleCalendarBlur(dt,col.field,col.filterMatchMode,filterDynamicCalendar)" appendTo="body"
                        dateFormat="dd.mm.yy" [locale]="DE"
                        *ngSwitchCase="crudItemService.propertyTypes!=null && crudItemService.propertyTypeOf!=null && crudItemService.propertyTypeOf(col.field)!=null && crudItemService.propertyTypeOf(col.field).type=='DateTime' || (col.field === 'modified') || (col.field === 'created')">
                      </p-calendar>-->
            <p-calendar #filterDynamicCalendar selectionMode="range" [readonlyInput]="true" [showWeek]="true" appendTo="body"
              dateFormat="dd.mm.yy" [locale]="DE"
              *ngSwitchCase="crudItemService.propertyTypes!=null && crudItemService.propertyTypeOf!=null && crudItemService.propertyTypeOf(col.field)!=null && crudItemService.propertyTypeOf(col.field).type=='DateTime' || crudItemService.propertyTypeOf(col.field).type=='DateTimeOffset' || (col.field === 'modified') || (col.field === 'created')"
              (onShow)="filterCalendarRangeShow(filterDynamicCalendar)"
              (onClose)="filterCalendarRangeClose(dt,col.field,col.filterMatchMode,filterDynamicCalendar)">
              <ng-template pTemplate="footer">
                <button pButton type="button" label="OK"
                  (click)="filterCalendarRange(dt,col.field,col.filterMatchMode,filterDynamicCalendar)"
                  class="p-button-text"></button>
                <button pButton style="float: right;" type="button" label="Löschen"
                  (click)="filterCalendarRangeClear(dt,col.field,col.filterMatchMode,filterDynamicCalendar)"
                  class="p-button-text"></button>
              </ng-template>
            </p-calendar>
          
            <!-- width: 100% ist wichtig, damit die checkbox linksbündig steht -->
            <p-triStateCheckbox #filterDynamicCheckbox
              *ngSwitchCase="crudItemService.propertyTypes!=null && crudItemService.propertyTypeOf!=null && crudItemService.propertyTypeOf(col.field)!=null && crudItemService.propertyTypeOf(col.field).type=='bool'"
              [style]="{width: '100%'}"
              (onChange)="filterCheckBoxChanged(dt,col.field,col.filterMatchMode,filterDynamicCheckbox)">
            </p-triStateCheckbox>
          
            <p-multiSelect [__style]="{'width': '--webkit-fill-available'}" class="CRUDBasicListHeaderFilterMulitSelect"
              appendTo="body" [(ngModel)]="col.selectFromInit" [defaultLabel]="translate.instant('alle',true)"
              [options]="col.selectFromValues" optionLabel="label"
              (onChange)="filterMultiSelectChanged(dt,col.field,col.filterMatchMode,$event)"
              *ngSwitchCase="col.selectFromValues != null"></p-multiSelect>
          
            <input [id]="'filter_' + col.field" *ngSwitchDefault pInputText type="text"
              (input)="datatable_filter($event.target.value, col.field, col.filterMatchMode)">
          </th>
          </ng-container>
          <th class="CRUD_HideSplitColumn" *ngIf="CRUDHideMehrButton != true"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-CRUDItem let-columns="columns">
    <tr #tr [pSelectableRow]="CRUDItem" (click)="clickTR(tr)">
      <ng-container *ngFor="let col of columns">
        <!--<td *ngFor="let col of columns" [ngSwitch]="true">-->
        <td [ngSwitch]="true" [class]="col.tdStyleClass"><!--MODI:style.width  [style.width]="(100 / (cols.length+1))+'%'"-->
          <div [style.height]="CRUDLazyLoadVirtualRowHeight != null ? (CRUDLazyLoadVirtualRowHeight-17)+'px' : null"
            [style.overflow]="CRUDLazyLoadVirtualRowHeight != null ? 'hidden' : null"
            pTooltip="{{CRUDItem[splitFieldName(col.field, false)] | crudBasic:splitFieldName(col.field, true): (crudItemService.propertyTypes!=null&&crudItemService.propertyTypeOf!=null?crudItemService.propertyTypeOf(col.field):null)}}"
              tooltipPosition="top"><!-- MODI: pToolTip: muss auch schon hier auf der div sein (nicht unten im span) - sonst kommt es bei langen Texten zu Positionsverscheibungen -->
            <!-- bei lazyLoading / virtualScroll muss die TR eine fixe Grösse haben, sonst Scrolling ungenau - wird dynmisch gesetzt -->
            <!-- warum CRUDLazyLoadVirtualRowHeight-17 ?: Provisorium: eine TR ist 117 px hoch -->
            <span
              *ngSwitchCase="col.field === 'modified' || col.field === 'created'">{{CRUDItem[col.field] | crudBasic:'':propertyTypeModifiedAndCreated }}
            </span>
            <span
              *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==null">
              <crud-basic-checkbox [disabled]="true" [nullable]="isCRUDItemNullable(splitFieldName(col.field, false))"
                [ngModel]="null"></crud-basic-checkbox>
            </span>
            <span
              *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==true">
              <crud-basic-checkbox [disabled]="true" [nullable]="isCRUDItemNullable(splitFieldName(col.field, false))"
                [ngModel]="true"></crud-basic-checkbox>
            </span>
            <span
              *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==false">
              <crud-basic-checkbox [disabled]="true" [nullable]="isCRUDItemNullable(splitFieldName(col.field, false))"
                [ngModel]="false"></crud-basic-checkbox>
            </span>
            <!--
        <span *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==null">
          <p-triStateCheckbox disabled [ngModel]="null"></p-triStateCheckbox>
        </span>
        <span *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==true">
          <p-triStateCheckbox disabled [ngModel]="true"></p-triStateCheckbox>
        </span>
        <span *ngSwitchCase="typeOfCRUDItem(col.field)=='boolean' && CRUDItem[splitFieldName(col.field, false)]==false">
          <p-triStateCheckbox disabled [ngModel]="false"></p-triStateCheckbox>
        </span>
      -->
            <!--
        <span *ngSwitchCase="typeOf(CRUDItem[splitFieldName(col.field, false)])=='boolean' && CRUDItem[splitFieldName(col.field, false)]==true">
          <p-triStateCheckbox disabled [ngModel]="true"></p-triStateCheckbox>
        </span>
        <span *ngSwitchCase="typeOf(CRUDItem[splitFieldName(col.field, false)])=='boolean' && CRUDItem[splitFieldName(col.field, false)]==false">
          <p-triStateCheckbox disabled [ngModel]="false"></p-triStateCheckbox>
        </span>
      -->

            <!-- HTML Text als innerHTML ausgeben: https://medium.com/@AAlakkad/angular-2-display-html-without-sanitizing-filtering-17499024b079 -->
            <!-- US 27617 24.08.2022: Erweiterung für Kombination aus customPipe und HTML -->
            <span *ngSwitchCase="(col.customPipe==null || col.customPipe==undefined) && col.spezialContentType!=null && col.spezialContentType=='HTML'"
              [class]="col.styleClass" [innerHTML]="CRUDItem[splitFieldName(col.field, false)] | keepHtml">
            </span>

            <!-- coustomPipe Asyc: does not work yet !!!-->
            <span *ngSwitchCase="col.customPipe!=null && col.customPipeAsync!=true && col.spezialContentType!='HTML'"
              [class]="col.styleClass">{{ transformByCustomPipe(col.field,CRUDItem[splitFieldName(col.field, false)]) }}
            </span>
            <span *ngSwitchCase="col.customPipe!=null && col.customPipeAsync==true && col.spezialContentType!='HTML'"
              [class]="col.styleClass">{{ transformByCustomPipe(col.field,CRUDItem[splitFieldName(col.field, false)], true) | async }}
            </span>

            <span *ngSwitchCase="col.customPipe!=null && col.customPipeAsync!=true && col.spezialContentType!=null && col.spezialContentType=='HTML'"
              [class]="col.styleClass" [innerHTML]="transformByCustomPipe(col.field,CRUDItem[splitFieldName(col.field, false)])">
            </span>
            <!--<span *ngSwitchDefault [class]="col.styleClass">{{CRUDItem[splitFieldName(col.field, false)] | crudBasic:splitFieldName(col.field, true): (crudItemService.typeOf!=null?crudItemService.typeOf(col.field):null) }}   /*3. parm: falls der service typeOf() unterstützt - mitgeben!*/   </span>-->
            <span *ngSwitchDefault [class]="col.styleClass"
              [innerHTML]="CRUDItem[splitFieldName(col.field, false)] | crudBasic:splitFieldName(col.field, true): (crudItemService.propertyTypes!=null&&crudItemService.propertyTypeOf!=null?crudItemService.propertyTypeOf(col.field):null)"
              >
            </span>
          </div>
        </td>
      </ng-container>
      <td class="CRUD_HideSplitColumn"><!--MODI: style="width: 10em;" entfernt!-->
        <div style="margin-left: auto; margin-right: 0;"><!--MODI: margin right für rechtsbündig-->
          <p-splitButton id="splitBtn_{{CRUDItem.id}}" [label]="translate.instant('Mehr',true)" icon="fa fa-bars"
            (onClick)="openDropdownMenu(CRUDItem)" (onDropdownClick)="dropdownClicked(CRUDItem)" [model]="buttonItems"
            appendTo="body" [style]="{'word-wrap': 'normal'}"></p-splitButton>
          <!-- word-wrap: normal - weil: die ListComponent wird teils auch innerhalb eines cardContainers verwendet (Beispiel EingangsrechnungFreigabeCustomizingDetailComponent)-->
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>
<!--<ng-template #CRUDTemplatePluginTop_dummy>
</ng-template>-->
<button *ngIf="debugMode == true" pButton (click)="debug(form)" icon="fa-bug" title="debug form"></button>
